import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

import LogoErpWorks from '../../../assets/logos/Logo ErpWorks Full.png';

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#ffffff',
    fontFamily: 'Helvetica',
    paddingBottom: '32px',
  },
  container: {
    flex: 1,
    paddingHorizontal: '24px',
    // paddingTop: '90px',
  },
  barraSup: {
    height: '16px',
    backgroundColor: '#5269a7',
    width: '100%',
    marginBottom: '20px',
  },
  headerContainer: {
    // marginBottom: '20px',

    // position: 'absolute',
    // top: 0,
    // left: 0,
    // right: 0,
    height: 100,
    width: '100%',
  },
  headerContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: '24px',
  },
  logo: {
    width: '120px',
    height: 'auto',
  },
  headerText: {
    textAlign: 'right',
  },
  titleColumn: {
    fontSize: '10pt',
    fontWeight: 'bold',
    color: '#ffffff',
  },
  titleText: {
    fontSize: '10pt',
    fontWeight: 'normal',
    color: '#333333',
  },
  titleData: {
    fontSize: '10pt',
    color: '#333333',
  },
  body: {
    flex: 1,
  },
  topSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    padding: '10px',
  },
  projectTitle: {
    fontSize: '14pt',
    fontWeight: 'bold',
    color: '#5269a7',
    marginBottom: '5px',
  },
  subtitle: {
    fontSize: '10pt',
    color: '#333333',
  },
  numeroOs: {
    fontSize: '12pt',
    fontWeight: 'bold',
    color: '#5269a7',
  },
  midSection: {
    marginBottom: '20px',
  },
  columns: {
    flexDirection: 'row',
    backgroundColor: '#5269a7',
    padding: '10px',
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
  },
  column: {
    flex: 1,
    textAlign: 'center',
    justifyContent: 'center',
  },
  rows: {
    flexDirection: 'row',
    padding: '10px',
    backgroundColor: '#eff1f8',
    borderBottomLeftRadius: '6px',
    borderBottomRightRadius: '6px',
  },
  activeColumn: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  activeColumnText: {
    fontSize: '10pt',
    fontWeight: 'bold',
    color: '#5269a7',

    backgroundColor: '#d7e1ff',
    padding: '4px 8px',
    borderRadius: '6px',
  },
  bottomSection: {
    marginTop: '20px',
    gap: '8px',
  },
  activitySection: {
    marginBottom: '15px',
    padding: '10px',
    backgroundColor: '#f9f9f9',
    borderRadius: '6px',
  },
  activityTitle: {
    fontSize: '11pt',
    fontWeight: 'bold',
    color: '#333333',
    marginBottom: '5px',
  },
  activityDescription: {
    fontSize: '9pt',
    color: '#555555',
    whiteSpace: 'pre-wrap',
  },
  ticketsSection: {
    marginTop: '20px',
    marginBottom: '20px',
  },
  ticketsTitle: {
    fontSize: '12pt',
    fontWeight: 'bold',
    color: '#5269a7',
  },
  ticketsContainer: {
    marginTop: '10px',
  },
  ticketColumns: {
    flexDirection: 'row',
    backgroundColor: '#5269a7',
    padding: '10px',
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
  },
  ticketColumn: {
    flex: 1,
    textAlign: 'center',
    justifyContent: 'center',
  },
  ticketColumnLeft: {
    flex: 2,
    fontSize: '9pt',
    fontWeight: 'bold',
    textAlign: 'left',
  },
  ticketRows: {
    borderBottomWidth: '1px',
    borderBottomColor: '#eeeeee',
    flexDirection: 'row',
    padding: '8px',
    backgroundColor: '#eff1f8',
  },
  ticketCell: {
    flex: 1,
    fontSize: '9pt',
    textAlign: 'center',
  },
  ticketCellLeft: {
    flex: 2,
    fontSize: '9pt',
    textAlign: 'left',
  },
  footer: {
    // position: 'absolute',
    // bottom: 0,
    // left: 0,
    // right: 0,
    // width: '100%',
    // textAlign: 'center',
    // fontSize: 10,
    // padding: 10,
    // color: '#888',
    // backgroundColor: '#5269a770',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '30px',
    borderTopWidth: '1px',
    borderTopColor: '#eeeeee',
    paddingTop: '20px',
  },
  analista: {
    flex: 1,
    paddingRight: '20px',
  },
  cliente: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  barraAssina: {
    height: '2px',
    backgroundColor: '#5269a7',
    width: '100%',
    marginBottom: '10px',
  },
  clienteLogo: {
    width: '60px',
    height: 'auto',
  },
  footerText: {
    flex: 1,
  },
  dataHeader: {
    backgroundColor: '#5269a7',
    color: 'white',
    padding: '10px',
    fontSize: '14pt',
    fontWeight: 'bold',
    marginBottom: '15px',
    textAlign: 'center',
  },
  pageIndicator: {
    position: 'absolute',
    bottom: 30,
    right: 30,
    fontSize: '8pt',
    color: '#888',
  },
  assinaturas: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '60px',
    paddingTop: '20px',
  },
});

const OsHeader = ({ os }) => (
  <View style={styles.headerContainer} fixed>
    <View style={styles.barraSup} />
    <View style={styles.headerContent}>
      <Image src={LogoErpWorks} style={styles.logo} />
      <View style={styles.headerText}>
        <Text style={styles.titleText}>Data da OS</Text>
        <Text style={styles.titleData}>{os?.dataEmissaoMascara}</Text>
      </View>
    </View>
  </View>
);

const OsFooter = ({ os }) => (
  <View style={styles.assinaturas} wrap>
    <View style={styles.analista}>
      <View style={styles.barraAssina} />
      <View>
        <Text style={styles.titleText}>Analista</Text>
        <Text style={styles.subtitle}>{os?.analista?.nome}</Text>
      </View>
    </View>

    <View style={styles.footerText}>
      <View style={styles.barraAssina} />
      <View style={styles.cliente}>
        <View>
          <Text style={styles.titleText}>{os?.cliente?.nomeFantasia}</Text>
          <Text style={styles.subtitle}>{os?.projeto?.solicitante_cliente?.nome}</Text>
        </View>
      </View>
    </View>
  </View>
);

const getTotalPosHorario = os => {
  if (os?.tipoOS !== 'S') return '00:00';

  let minutos = 0;
  os?.atividades?.forEach(atividade => {
    atividade?.tarefas?.forEach(tarefa => {
      if (tarefa?.excluido) return;

      if (tarefa?.posHorario) {
        minutos += tarefa?.horaTotalMinuto || 0;
      }
    });
  });

  const horas = Math.floor(minutos / 60);
  const mins = minutos % 60;
  return `${String(horas).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

const OsHorasSection = ({ os }) => (
  <View style={styles.midSection}>
    <View style={styles.columns}>
      <View style={styles.column}>
        <Text style={styles.titleColumn}>Total Trabalhado</Text>
      </View>
      <View style={styles.column}>
        <Text style={styles.titleColumn}>Total Desconto</Text>
      </View>
      <View style={styles.column}>
        <Text style={styles.titleColumn}>Total Translado</Text>
      </View>
      <View style={styles.column}>
        <Text style={styles.titleColumn}>Total SRP Autorizado</Text>
      </View>
      <View style={styles.column}>
        <Text style={styles.titleColumn}>Total de Horas</Text>
      </View>
    </View>

    <View style={styles.rows}>
      <View style={styles.column}>
        <Text style={styles.titleText}>{(os?.horaApontadaMascara + '').replace(':', 'h')}</Text>
      </View>
      <View style={styles.column}>
        <Text style={styles.titleText}>{(os?.horaDescontoMascara + '').replace(':', 'h')}</Text>
      </View>
      <View style={styles.column}>
        <Text style={styles.titleText}>{(os?.horaTransladoMascara + '').replace(':', 'h')}</Text>
      </View>
      <View style={styles.column}>
        <Text style={styles.titleText}>{getTotalPosHorario(os).replace(':', 'h')}</Text>
      </View>
      <View style={[styles.column, styles.activeColumn]}>
        <Text style={[styles.titleText, styles.activeColumnText]}>
          {(os?.horaTotalMascara + '').replace(':', 'h')}
        </Text>
      </View>
    </View>
  </View>
);

const OsAtividadesSection = ({ os }) => (
  <View style={styles.bottomSection} wrap>
    <View>
      <Text style={styles.projectTitle}>{os?.titulo}</Text>
      <Text style={styles.subtitle}>Data: {os?.dataEmissaoMascara}</Text>
    </View>

    {os?.atividades?.map((thisAtiv, c) => (
      <View style={styles.activitySection} key={`ativ-${c}`} wrap>
        <Text style={styles.activityTitle}>{thisAtiv?.projetoAtividade?.titulo}</Text>
        <Text style={styles.activityDescription}>{thisAtiv?.descricao}</Text>
      </View>
    ))}
  </View>
);

const OsTicketsSection = ({ os }) => {
  const ticketTarefas = [];
  os.atividades?.forEach(atividade => {
    atividade.tarefas?.forEach(tarefa => {
      if (tarefa?.excluido) return;

      ticketTarefas.push(tarefa);
      // if (tarefa.idMoviDeskTicket) {
      // }
    });
  });

  if (ticketTarefas.length === 0) {
    return null;
  }

  return (
    <View style={styles.ticketsSection}>
      <Text style={styles.ticketsTitle}>Tickets MoviDesk Relacionados:</Text>

      <View style={styles.ticketsContainer} wrap>
        <View style={styles.ticketColumns} fixed>
          <View style={styles.ticketColumn}>
            <Text style={styles.titleColumn}>ID MoviDesk</Text>
          </View>
          <View style={styles.ticketColumnLeft}>
            <Text style={styles.titleColumn}>Título</Text>
          </View>
          <View style={styles.ticketColumn}>
            <Text style={styles.titleColumn}>Cliente</Text>
          </View>
          <View style={styles.ticketColumn}>
            <Text style={styles.titleColumn}>Horas</Text>
          </View>
        </View>

        {ticketTarefas.map((tarefa, ticketIndex) => {
          const isLastRow = ticketIndex === ticketTarefas.length - 1;

          const totalMinutos =
            tarefa?.horarios?.reduce((acc, horario) => {
              if (horario?.horaTotalMascara) {
                const [horas, mins] = horario.horaTotalMascara.split(':').map(Number);
                return acc + horas * 60 + mins;
              }
              return acc;
            }, 0) || 0;

          const horas = Math.floor(totalMinutos / 60);
          const minutos = totalMinutos % 60;
          const horaCalculada = `${horas.toString().padStart(2, '0')}h${minutos
            .toString()
            .padStart(2, '0')}`;

          return (
            <View
              style={[
                styles.ticketRows,
                isLastRow && {
                  borderBottomWidth: 0,
                  borderBottomLeftRadius: '6px',
                  borderBottomRightRadius: '6px',
                },
              ]}
              key={`ticket-${ticketIndex}`}
              wrap={false}
            >
              <View style={styles.ticketCell}>
                <Text style={styles.titleText}>
                  {tarefa?.idMoviDeskTicket ? `#${tarefa?.idMoviDeskTicket}` : '-'}
                </Text>
              </View>
              <View style={styles.ticketCellLeft}>
                <Text style={styles.titleText}>{tarefa?.ticket?.titulo ?? tarefa?.titulo}</Text>
              </View>
              <View style={styles.ticketCell}>
                <Text style={styles.titleText}>
                  {tarefa?.ticket?.cliente?.nomeFantasia ?? 'ERPWorks'}
                </Text>
              </View>
              <View style={[styles.column, styles.activeColumn]}>
                <Text style={[styles.titleText, styles.activeColumnText]}>{horaCalculada}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};

function agruparPorData(osData) {
  const dadosAgrupados = {};

  osData?.data?.forEach(item => {
    item.forEach(os => {
      const dataOS = os.dataEmissaoMascara;

      if (!dadosAgrupados[dataOS]) {
        dadosAgrupados[dataOS] = [];
      }

      dadosAgrupados[dataOS].push(os);
    });
  });

  return Object.entries(dadosAgrupados)
    .sort(([dataA], [dataB]) => {
      const [diaA, mesA, anoA] = dataA.split('/').map(Number);
      const [diaB, mesB, anoB] = dataB.split('/').map(Number);
      return new Date(anoA, mesA - 1, diaA) - new Date(anoB, mesB - 1, diaB);
    })
    .map(([data, osList]) => ({
      data,
      ordens: osList,
    }));
}

export default function RelatorioOsPDF(osData) {
  const dadosAgrupados = agruparPorData(osData);

  return (
    <Document>
      {dadosAgrupados.map((grupo, indexGrupo) =>
        grupo.ordens.map((os, indexOS) => (
          <Page key={`os-${indexGrupo}-${indexOS}`} size="A4" style={styles.page}>
            <OsHeader os={os} />
            <View style={styles.container} wrap>
              <View style={styles.topSection}>
                <View>
                  <Text style={styles.projectTitle}>{os?.projeto?.titulo}</Text>
                  <Text style={styles.subtitle}>
                    Coordenador(a): {os?.coordenador?.nome + ' / ' + os?.coordenadorTec?.nome}
                  </Text>
                </View>
                <View>
                  <Text style={styles.numeroOs}>Nº #{os?.id}</Text>
                </View>
              </View>

              <OsHorasSection os={os} />
              <OsAtividadesSection os={os} />
              <OsTicketsSection os={os} />
              <OsFooter os={os} />
            </View>

            <Text
              style={styles.pageIndicator}
              render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
              fixed
            />
          </Page>
        )),
      )}
    </Document>
  );
}
